import { useTranslation } from 'react-i18next'
import React from 'react'
import styled from 'styled-components'
import { colors } from 'styles/colors'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { zones } from '.'
import { displayWidth } from 'styles/width'

const LoadMore = styled.span`
    color: ${colors.accentText};
`

const RowWithPadding = styled.p`
    margin-bottom: 20px;
`

const TippyS = styled(Tippy)`
    background: white;
    border: 1px solid #333;
`

const Block = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 8px;
    flex: 1;
    color: ${colors.dark};
    margin: 10px;
`

const Flex = styled.div<{ all?: boolean }>`
    display: flex;
    @media (min-width: ${displayWidth.tablet}) {
        margin-left: ${({ all }) => !!all && '70px'};
    }
`

export const AvailableFiltersList = ({
    filters,
    all = false,
}: {
    filters: { [x: string]: string }
    all?: boolean
}) => {
    const { t } = useTranslation()
    const separate = [
        'houseArea',
        'houseWidth',
        'houseHeight',
        'ceilingHeight',
        'floor',
        'project',
        'type',
        'mansard',
    ]

    const zoneFiltered = all
        ? Object.keys(filters)
              .filter((a) => filters[a])
              .filter((a) => !separate.some((z) => z == a))
        : Object.keys(filters)
              .filter((a) => zones.some((z) => z.label === a) && filters[a])
              .filter((a) => !separate.some((z) => z == a))

    const firstPart = all ? zoneFiltered : zoneFiltered.slice(0, 8)
    const secondPart = all ? [] : zoneFiltered.slice(8)

    return (
        <Flex all={all}>
            <Block>
                {firstPart.map((a: string) => {
                    return (
                        <p key={a}>
                            {t(`houses.${a}`)}

                            {typeof filters[a] === 'string'
                                ? ` - ${t(`houses.${filters[a]}`)}`
                                : null}
                            {typeof filters[a] === 'number'
                                ? ` - ${filters[a]} `
                                : null}
                        </p>
                    )
                })}
                {secondPart.length ? (
                    <TippyS
                        content={
                            <Block>
                                {secondPart.map((a) => {
                                    return (
                                        <p key={a}>
                                            {t(`houses.${a}`)}

                                            {typeof filters[a] === 'string'
                                                ? ` - ${t(
                                                      `houses.${filters[a]}`
                                                  )}`
                                                : null}
                                            {typeof filters[a] === 'number'
                                                ? ` - ${filters[a]} `
                                                : null}
                                        </p>
                                    )
                                })}
                            </Block>
                        }
                        arrow={false}
                        placement="left"
                    >
                        <LoadMore>{t('see_more')}</LoadMore>
                    </TippyS>
                ) : null}
            </Block>
            <Block>
                <RowWithPadding>
                    {`${t(`houses.houseArea`)} - ${filters.houseArea} ${t(
                        'm'
                    )}`}
                    <sup>2</sup>
                </RowWithPadding>
                <p>{`${t(`houses.houseWidth`)} - ${filters.houseWidth} ${t(
                    'm'
                )}`}</p>
                <p>{`${t(`houses.houseHeight`)} - ${filters.houseHeight} ${t(
                    'm'
                )}`}</p>
                <p>{`${t(`houses.ceilingHeight`)} - ${
                    filters.ceilingHeight
                } ${t('m')}`}</p>
                <p>{`${t(`houses.floor`)} - ${filters.floor}`}</p>
            </Block>
        </Flex>
    )
}

export const AvailableFiltersListCard = ({
    filters,
}: {
    filters: { [x: string]: string }
}) => {
    const { t } = useTranslation()
    const separate = [
        'houseArea',
        'houseWidth',
        'houseHeight',
        'ceilingHeight',
        'floor',
        'project',
        'type',
        'mansard',
    ]

    const zoneFiltered = Object.keys(filters)
        .filter((a) => zones.some((z) => z.label === a) && filters[a])
        .filter((a) => !separate.some((z) => z == a))

    const firstPart = zoneFiltered.slice(0, 8)
    const secondPart = zoneFiltered.slice(8)

    return (
        <Flex>
            <Block>
                <RowWithPadding>
                    {`${t(`houses.houseArea`)} - ${filters.houseArea} ${t(
                        'm'
                    )}`}
                    <sup>2</sup>
                </RowWithPadding>

                <p>{`${t(`houses.floor`)} - ${filters.floor}`}</p>
                {firstPart.map((a: string) => {
                    return (
                        <p key={a}>
                            {a === 'garageType'
                                ? t(`houses.garage`)
                                : t(`houses.${a}`)}

                            {typeof filters[a] === 'string'
                                ? ` - ${t(`houses.${filters[a]}`)}`
                                : null}
                            {typeof filters[a] === 'number'
                                ? ` - ${filters[a]} `
                                : null}
                        </p>
                    )
                })}
                {secondPart.length ? (
                    <TippyS
                        content={
                            <Block>
                                {secondPart.map((a) => {
                                    return (
                                        <p key={a}>
                                            {a === 'garageType'
                                                ? t(`houses.garage`)
                                                : t(`houses.${a}`)}

                                            {typeof filters[a] === 'string'
                                                ? ` - ${t(
                                                      `houses.${filters[a]}`
                                                  )}`
                                                : null}
                                            {typeof filters[a] === 'number'
                                                ? ` - ${filters[a]} ${t(
                                                      'houses.ps'
                                                  )}`
                                                : null}
                                        </p>
                                    )
                                })}
                            </Block>
                        }
                        arrow={false}
                        placement="left"
                    >
                        <LoadMore>{t('see_more')}</LoadMore>
                    </TippyS>
                ) : null}
            </Block>
        </Flex>
    )
}
